import { createFileRoute } from '@tanstack/react-router'
import { InvalidMeetingPage } from '@/components/meeting/invalid-page'
export const Route = createFileRoute('/meeting/join/')({ component: InvalidMeetingPage })
